<template>
  <div class="member-information">
    <div class="common-header-wrap">
      <mt-header :title="$t('Personal Info')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <!-- <div class="user-avatar iconfont icon-xiangji" @change="uploadImage($event)"> -->
    <div class="user-avatar iconfont icon-xiangji">
      <!-- <img :src="user.member_avatar"> -->
      <img class="avatar" src="../../../assets/image/member/favicon.png" />
      <!-- <input type="file" accept="image/*"> -->
    </div>

    <div class="form">

      <flex-line class="menu-item" :show-border="true">
        <span class="field-line field-name">
          {{ $t('Username') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="member_info.member_name" readonly />
        </div>
      </flex-line>

      <flex-line class="menu-item" :show-border="true">
        <span class="field-line field-name">
          {{ $t('Full Name') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="member_info.member_nickname" readonly />
        </div>
      </flex-line>

      <flex-line class="menu-item" :show-border="true">
        <span class="field-line field-name">
          {{ $t('Email') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="member_info.member_email" readonly />
        </div>
      </flex-line>

      <flex-line class="menu-item" :show-border="true">
        <span class="field-line field-name">
          {{ $t('Invitation code') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="member_info.w_code" readonly />
          <div class="copy button" @click.stop="copySuccess(member_info.w_code)">{{ $t('Copy') }}</div>
        </div>
      </flex-line>

      <flex-line class="menu-item" :show-border="true">
        <span class="field-line field-name">
          {{ $t('Delivery Address') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="address" readonly />
        </div>
      </flex-line>

      <flex-line class="menu-item" :show-border="true" v-if="member_info">
        <span class="field-line field-name">
          {{ $t('USDT Address (TRC20)') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="member_info.member_bank.memberbank_no" readonly />
        </div>
      </flex-line>

      <!-- <flex-line class="menu-item" :show-border="true"><span class="field-line field-name">QQ</span>
        <div class="field-line-right" slot="right"><input class="field-input" v-model="member_info.member_qq" /></div>
      </flex-line>
      <flex-line class="menu-item" :show-border="true"><span class="field-line field-name">旺旺</span>
        <div class="field-line-right" slot="right"><input class="field-input" v-model="member_info.member_ww" /></div>
      </flex-line> -->
      <!-- <div @click="onTime">
        <flex-line class="menu-item" :is-link="true" :show-border="true">
          <span class="line-name">{{ $t('Birthdate') }}</span>
          <span slot="right">{{ member_info.member_birthday }}</span>
        </flex-line>
      </div> -->
      <!-- <div class="pt-10 pb-10">
        <div class="common-btn ds-button-large" @click="submitInformation">{{ $t('Save') }}</div>
      </div> -->

    </div>

    <mt-datetime-picker ref="timePicker" type="date" :startDate="new Date('1900/1/1')" :endDate="new Date()"
      :value="member_info.member_birthday ? (new Date(member_info.member_birthday)) : (new Date('1990/1/1'))"
      @confirm="timeConfirm">
    </mt-datetime-picker>

    <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('CropImage')" class="common-header">
          <mt-button slot="left" icon="back" @click="showCrop = false"></mt-button>
          <div class="common-btn btn" slot="right" @click="useCrop">{{ $t('UseImage') }}</div>
        </mt-header>
      </div>
      <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper"
        :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth"
        :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img"
        :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
    </mt-popup>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { uploadMemberAvatar, updateMemberInfo, upload_file } from '../../../api/member'
import { getMemberIndex } from '../../../api/member'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
    VueCropper
  },
  name: 'MemberProfileSet',
  data() {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      member_info: '',
      address: ''
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  created: function () {
    // if (this.user) {
    //   this.member_info.member_name = this.user.member_name
    //   this.member_info.member_nickname = this.user.member_nickname
    //   this.member_info.member_email = this.user.member_email
    //   this.member_info.member_id = this.user.member_id
    // }
    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.member_info = response.result.member_info
          this.address = response.result.member_info.member_address.length != 0 ? response.result.member_info.member_address.area_info + response.result.member_info.member_address.address_detail : ''
        }
      },
      error => { }
    )
  },

  methods: {
    ...mapMutations({
      memberEdit: 'memberEdit'
    }),
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t('succ'))
          // console.log(e);
        }, (e) => {
          Toast(this.$t('err'))
          // console.log(e);
        }
      );
    },
    uploadImage(event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    useCrop() {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        console.log(files, formdata);
        Indicator.open()
        upload_file(formdata).then(res => {
          this.user.avatar = res.result + '?' + Math.floor(Math.random() * 100)
          this.memberEdit({ member_avatar: this.user.avatar })
          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    timeConfirm(value) {
      this.member_info.member_birthday = value.getFullYear() + '/' + (value.getMonth() + 1) + '/' + value.getDate()
    },
    onTime(picker, values) {
      this.$refs.timePicker.open()
    },
    submitInformation() {
      updateMemberInfo(this.member_info).then(res => {
        this.memberEdit(this.member_info)
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
.common-header {
  background: #F1F1F1;
  box-shadow: none;

  .btn {
    background: #000;
    color: #fff;
    // box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.member-information {
  background: #F1F1F1;

  .form {
    background: #F9F9F9;
    padding: 5rem 1rem 1rem;
  }

  .user-avatar {
    position: relative;
    width: 6rem;
    height: 6rem;
    margin: 2rem auto;
    margin-bottom: -4rem;
    text-align: center;

    img {
      width: 100%;
      height: 100%
    }

    input {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0
    }
  }

  .user-avatar::before {
    display: none;
    position: absolute;
    font-size: 1.5rem;
    line-height: 5rem;
    left: 50%;
    margin-left: -.75rem;
    color: rgba(255, 255, 255, 0.5)
  }
}

.menu-item {
  flex-direction: column;
  align-items: flex-start;
  background: #F9F9F9;
  margin: 1rem 0;
}

::v-deep(.flex-line) {
  .right {
    width: 100%;

    .field-line-right {
      position: relative;
      width: 100%;
      margin-top: 10px;
    }

    input {
      width: 100%;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 15px 15px 15px 15px;
      border: 1px solid #E7010C;
      padding: 1rem .6rem;
    }
  }
}

.copy {
  color: $primaryColor;
  font-weight: 600;
  font-size: .6rem;
  position: absolute;
  top: 50%;
  right: .5rem;
  transform: translate(-50%, -50%);
}
</style>
